exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".legend p {\n  text-align: center; }\n\n.legend ul {\n  margin-left: 0;\n  padding: 0;\n  list-style-type: none; }\n\n.legend li {\n  display: inline-flex; }\n\n.legend li .fa-li {\n  position: static; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/additional-resources/student-file-uploads/student-file-uploads.component.scss
// module id = 9dyZ
// module chunks = 2